import React, { useState } from 'react'
import { Box, Button, Text } from '@indeed/ifl-components'
import { useFormatDateTime } from 'syft-acp-core/lib/hooks'

import { SchedulingPlanDialog, useSchedulingPlan } from 'syft-acp-core/components/SchedulingPlanDialog'

const dateTimeFormat = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: 'numeric',
  minute: '2-digit',
  timeZoneName: 'short',
} as const

type BookingPlanProps = {
  allocationId: number
  deadline: string
  jobId: number
  planId: number
  venueTimezone: string
}

export const BookingPlan = ({ allocationId, deadline, jobId, planId, venueTimezone }: BookingPlanProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const { requestPlan } = useSchedulingPlan(planId)
  const [, formatDateTime] = useFormatDateTime()
  const format = { ...dateTimeFormat, timeZone: venueTimezone }

  return (
    <>
      <Box>
        <Text as="strong" level={1} sx={{ display: 'block', textTransform: 'uppercase' }}>
          Booking deadline
        </Text>
        <Text as="div">
          {deadline && !Number.isNaN(Date.parse(deadline))
            ? formatDateTime(deadline, { format })
            : deadline || '—'}
        </Text>
        <Button
          type="button"
          variant="text"
          size="sm"
          aria-label={`View plan for agency allocation ${allocationId}`}
          sx={{ fontSize: 2, fontWeight: 'normal' }}
          onClick={event => {
            event.preventDefault()
            event.stopPropagation()
            requestPlan()
            setIsOpen(true)
          }}
        >
          View plan
        </Button>
      </Box>

      {isOpen && (
        <SchedulingPlanDialog
          description={`Job #${jobId} · agency allocation #${allocationId}`}
          onOpenChange={setIsOpen}
          planId={planId}
          venueTimezone={venueTimezone}
        />
      )}
    </>
  )
}
